/**
 * anything that relates to DOM
 */
export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    inViewSection: null,
    /**
     * breakpoint constants
     */
    widthExtraSmall: 320,
    widthMobile: 480,
    widthTablet: 768,
  },
  actions: {
    setInviewSection({ commit, dispatch }, name) {
      commit("SET_INVIEW_SECTOIN", name);
    },
  },
  mutations: {
    SET_WINDOW_WIDTH(state, value) {
      state.windowWidth = value;
    },
    SET_INVIEW_SECTOIN(state, value) {
      state.inViewSection = value;
    },
  },

  getters: {
    isExtraSmall: (state) => state.windowWidth <= state.widthExtraSmall,
    isMobile: (state) => state.windowWidth <= state.widthMobile,
    isTablet: (state) => state.windowWidth <= state.widthTablet,
    isDesktop: (state) => state.windowWidth > state.widthTablet,
    getInViewSecion: (state) => state.inViewSection,
  },
};
